import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssignEmployeeComponent } from './assign-employee.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    AssignEmployeeComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    AssignEmployeeComponent
  ]
})
export class AssignEmployeeModule { }
